import { BuildingSpecification } from '../BuildingSpecification';

export const getBuildingTitle = (
  buildingSpecification: BuildingSpecification
): string | undefined => buildingSpecification.title;
